import { makeSubStore } from '@jarvis.oddle/core/tools/redux/store'
import { STORE_KEY } from './constants'
import * as actions from './actions'
import { initialState, reducers } from './reducers'

const getStoreOrderIdParams = ({ req, storeOrderId, metaState }) => {
  return { storeOrderId: req ? storeOrderId : metaState.detailMenuSite.data.storeOrderId, req }
}

const initialiseState = async ({ req, store, parsedUrl }) => {
  const metaState = store.getState()['@meta']
  const { path } = parsedUrl
  const isInvoicePage = path[0] === 'invoice'
  const storeOrderId = isInvoicePage && path[1]
  const hashCode = isInvoicePage && path[2]

  const initialiseActions = []

  if (isInvoicePage) {
    initialiseActions.push(
      store.dispatch(actions.fetchInvoiceMetaAction({ ...getStoreOrderIdParams({ req, storeOrderId, metaState }), hashCode }))
    )

    initialiseActions.push(
      store.dispatch(actions.fetchInvoicePaymentMethodsAction({ ...getStoreOrderIdParams({ req, storeOrderId, metaState }), type: 'online' }))
    )
  }

  await Promise.all(initialiseActions)
}

export default makeSubStore(STORE_KEY, actions, reducers, initialState, initialiseState)
